import { Controller } from "stimulus"

// Bugfix 21 (#1391): zoeken terwijl je typt ("Joyce" geeft meteen de sporters
// die erop lijken). Verstuurt het zoekformulier na een korte pauze; zonder
// JavaScript werkt de Zoeken-knop gewoon.
export default class extends Controller {
  typ() {
    clearTimeout(this.wachten)
    this.wachten = setTimeout(() => {
      if (typeof this.element.requestSubmit === "function") this.element.requestSubmit()
    }, 300)
  }

  disconnect() {
    clearTimeout(this.wachten)
  }
}
